import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './QuizList.css'; // Assuming you have a separate CSS for this page

const QuizList = () => {
  const { courseId } = useParams(); // Get courseId from URL
  const location = useLocation(); // Access the location object to get query params
  const [quizzes, setQuizzes] = useState([]); // State to hold quizzes data
  const [userId, setUserId] = useState(null); // State to store userId
  const navigate = useNavigate(); // Hook to navigate to other pages

  // Extract userId from query parameters
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const extractedUserId = queryParams.get('userId'); // Get userId from the URL query parameters
    setUserId(extractedUserId); // Set the extracted userId in state
    console.log('User ID:', extractedUserId); // Log the userId to the console
  }, [location.search]);

  // Fetch quizzes when the courseId changes
  useEffect(() => {
    fetch(`https://schoolofservice.co.za/backend/get-quizzes.php?courseId=${courseId}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('Fetched quizzes:', data); // Log the fetched data for debugging
        setQuizzes(data); // Set quizzes data in state
      })
      .catch((error) => console.error('Error fetching quizzes:', error)); // Log any errors
  }, [courseId]);

  // Handle quiz click and navigate to QuizPage with courseId, quizId, and userId
  const handleQuizClick = (quizId) => {
    // Log the userId to the console before navigating
    console.log('User ID on quiz click:', userId);

    // Navigate to the quiz page with courseId, quizId, and userId
    navigate(`/quiz/${courseId}/${quizId}`, { state: { userId } });
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Quizzes for Course {courseId}</h2>
      {quizzes.length > 0 ? (
        <ul className="list-group">
          {quizzes.map((quiz) => (
            <li key={quiz.quizId} className="list-group-item d-flex justify-content-between align-items-center">
              {quiz.quizTitle}
              <button className="btn btn-primary" onClick={() => handleQuizClick(quiz.quizId)}>
                Start Quiz
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>No quizzes available for this course.</p>
      )}
    </div>
  );
};

export default QuizList;
